/* 130R — medição do funil do site (agente medicao, 18/10/2026). Incluído uma vez em layout/theme.liquid.
   Conta o que o cliente faz no site e entrega em dois lugares, sem dado pessoal:
     1. window.dataLayer.push({ event: '<nome>', ... })       formato GA4/GTM, nomes em minúsculas;
     2. Shopify.analytics.publish('r130_<nome>', { ... })     para um Custom Pixel (Configurações > Eventos do cliente).
   Privacidade: só entrega com Shopify.customerPrivacy.analyticsProcessingAllowed() = true, conferido na hora da entrega;
   sem consentimento, o evento é descartado. Ação que troca de página na hora (filtro, envio de formulário) fica na
   sessão desta aba só até a página seguinte, que entrega ou descarta. Chassi e carro vão só como "tem / não tem";
   o termo de busca sai sem e-mail, telefone, CPF, chassi e placa Mercosul.
   Conferência: ?r130medicao=1 no endereço mostra um painel com os eventos desta sessão (só nesta aba); ?r130medicao=0 tira.
   Eventos e campos: relatorios/site_medicao_20261018/RELATORIO.md. Este arquivo não muda nada do que o cliente vê
   (fora o painel de conferência): só escuta cliques, envios e os eventos que os outros scripts já disparam
   (r130:garagem, r130:carrinho, r130:carrinho-aberto, product-added, r130:chassi, r130:avise-me, r130:lead-b2b). */
(function () {
  'use strict';
  if (window.R130Medicao) return;

  var tag = document.currentScript;
  var ds = (tag && tag.dataset) || {};
  var FONE = '5511910801297';
  var K_DEBUG = 'r130_medicao', K_LOG = 'r130_medicao_log', K_PEND = 'r130_medicao_pendentes', K_PAINEL = 'r130_medicao_painel';

  /* ---------------- utilidades ---------------- */
  function ssLer(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssGravar(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function lsJson(k) { try { return JSON.parse(localStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function texto(s, max) { s = String(s == null ? '' : s).replace(/\s+/g, ' ').trim(); return s.slice(0, max || 100); }
  function temChassi() { var v = lsJson('r130_chassi'); return !!(v && v.vin); }
  function carroSalvo() { var c = lsJson('r130_garage'); return c && c.brand && c.model ? c : null; }
  function nomeMontadora(b) { b = texto(b, 30).toLowerCase(); return b.charAt(0).toUpperCase() + b.slice(1); }
  function perto(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  // Só conversas com a 130R (o mesmo critério do assets/r130-chassi.js).
  function ehWhats(url) {
    url = String(url || '');
    return /^(https?:\/\/(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\/|whatsapp:\/\/)/i.test(url) && url.indexOf(FONE) !== -1;
  }

  // Termo de busca sem dado pessoal. Código de peça (até 16 caracteres, ou 10 dígitos) passa.
  function anonimizar(t) {
    t = texto(t, 200);
    if (!t) return '';
    var compacto = t.replace(/[^A-Za-z0-9]/g, '');
    var pedacosComNumero = t.split(/[\s.\-]+/).every(function (p) { return /\d/.test(p); }); // "9BH BG51CA KP123456"
    if (compacto.length === 17 && pedacosComNumero && /[A-Za-z]/.test(compacto)) return '[chassi]';
    t = t.replace(/[^\s@]+@[^\s@]+/g, '[email]')
      .replace(/\b[A-Za-z0-9]{17}\b/g, function (m) { return /\d/.test(m) && /[A-Za-z]/.test(m) ? '[chassi]' : m; })
      .replace(/\b[A-Za-z]{3}-?\d[A-Za-z]\d{2}\b/g, '[placa]')
      .replace(/(^|[^A-Za-z0-9])(\+?\(?\d[\d\s().\/-]{8,}\d)/g, function (m, antes, n) {
        if (/^(\s*(19[5-9]\d|20[0-4]\d)\s*)+$/.test(n)) return m; // anos do carro ("hb20 2012 2013 2014")
        return n.replace(/\D/g, '').length >= 11 ? antes + '[numero]' : m;  // telefone, CPF, CNPJ
      });
    return t.slice(0, 100);
  }

  var TIPOS = { index: 'inicio', collection: 'colecao', product: 'produto', cart: 'carrinho', search: 'busca', page: 'pagina',
    article: 'artigo', blog: 'blog', 'list-collections': 'colecoes', captcha: 'captcha' };
  function pagina() {
    var t = ds.pagina || document.body && document.body.getAttribute('data-template') || '';
    return TIPOS[t] || texto(t, 30) || 'outra';
  }

  // De onde veio o clique: um bloco conhecido ou a seção do Shopify mais próxima (a chave do template, ex.: r130_hero).
  var BLOCOS = [
    ['#r130-chassi', 'painel_chassi'], ['#r130-garage-modal', 'meu_carro'], ['#r130-carrinho', 'gaveta_carrinho'],
    ['#mobile-bar', 'barra_celular'], ['#r130-gaveta', 'menu_celular'], ['.r130-sug', 'sugestoes_busca'],
    ['#whatsapp-widget-root', 'botao_flutuante'], ['#r130-avise', 'aviso_chegada']
  ];
  var APELIDOS = { 'header-style-1': 'header', 'mobile-bar': 'barra_celular', main: 'principal' };
  function secaoDe(el) {
    if (!el || el.nodeType !== 1) return '';
    for (var i = 0; i < BLOCOS.length; i++) if (perto(el, BLOCOS[i][0])) return BLOCOS[i][1];
    var s = perto(el, '[id^="shopify-section-"]');
    if (!s) return perto(el, 'header, #header') ? 'header' : (perto(el, 'footer') ? 'rodape' : '');
    var id = s.id.replace(/^shopify-section-/, '');
    var j = id.lastIndexOf('__');
    if (j >= 0) id = id.slice(j + 2);
    // Chave gerada pelo editor (ex.: 7bcbf5ce-…, 1602767199517): usa o tipo da seção, se o tema marcar (ex.: related-product).
    if (/^[0-9a-f]{8}-|^\d{8,}$|^[0-9a-f]{14,}$/i.test(id)) {
      var tipo = s.querySelector('[data-section-type]');
      if (tipo) id = tipo.getAttribute('data-section-type');
    }
    return APELIDOS[id] || texto(id, 60);
  }
  function contexto(el) {
    var sec = secaoDe(el) || 'pagina';
    var c = { secao: sec, origem: pagina() + '/' + sec };
    if (perto(el, '.r130-pc')) c.origem += '/cartao';
    return c;
  }
  function junta(a, b) { for (var k in b) if (Object.prototype.hasOwnProperty.call(b, k)) a[k] = b[k]; return a; }

  // Mesma ação vista por dois caminhos (link e window.open, por exemplo) conta uma vez só.
  var vistos = {};
  function recente(chave, ms) {
    var agora = Date.now();
    if (vistos[chave] && agora - vistos[chave] < ms) return true;
    vistos[chave] = agora;
    return false;
  }
  var umaVez = {};
  function primeiraVez(chave) { if (umaVez[chave]) return false; umaVez[chave] = 1; return true; }

  /* ---------------- conferência (?r130medicao=1) ---------------- */
  (function () {
    var m = /[?&]r130medicao=([01])(&|$)/.exec(location.search);
    if (m) ssGravar(K_DEBUG, m[1] === '1' ? '1' : null);
  })();
  var debug = ssLer(K_DEBUG) === '1';
  var previa = !!(window.Shopify && window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main');

  function lerLog() { try { return JSON.parse(ssLer(K_LOG) || '[]') || []; } catch (e) { return []; } }
  function registrar(nome, dados, status) {
    if (!debug) return;
    var log = lerLog();
    var d = new Date();
    log.push({ h: ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2), n: nome, d: dados, s: status });
    if (log.length > 60) log = log.slice(-60);
    ssGravar(K_LOG, JSON.stringify(log));
    try { console.info('[130R medição]', nome, status, dados); } catch (e) {}
    desenhar();
  }

  /* ---------------- privacidade (Customer Privacy API do Shopify) ---------------- */
  var priv = { fila: [], carregando: false };
  function apiPriv() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return p && typeof p.analyticsProcessingAllowed === 'function' ? p : null;
  }
  function analisePermitida(p) { try { return !!p.analyticsProcessingAllowed(); } catch (e) { return false; } }
  function soltarFila() {
    var p = apiPriv(), f = priv.fila;
    priv.fila = [];
    priv.carregando = false;
    f.forEach(function (fn) { fn(p); });
    desenhar();
  }
  function comPrivacidade(fn) {
    if (apiPriv()) return fn(apiPriv());
    priv.fila.push(fn);
    if (priv.carregando) return;
    priv.carregando = true;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () { soltarFila(); });
        setTimeout(function () { if (priv.fila.length) soltarFila(); }, 8000);
      } else soltarFila();
    } catch (e) { soltarFila(); }
  }

  /* ---------------- entrega ---------------- */
  function base() {
    var b = { pagina: pagina(), tem_chassi: temChassi(), tem_carro: !!carroSalvo() };
    if (debug || previa) b.debug_mode = true; // GA4: vai para o DebugView e sai dos relatórios com o filtro "tráfego de desenvolvedor"
    return b;
  }
  function limparDados(d) {
    var o = {};
    Object.keys(d).forEach(function (k) {
      var v = d[k];
      if (v === undefined || v === null || v === '') return;
      o[k] = typeof v === 'string' ? texto(v, 100) : v;
    });
    return o;
  }
  function entregar(nome, dados, nota) {
    comPrivacidade(function (p) {
      var status;
      if (!p) status = 'bloqueado: sem API de privacidade';
      else if (!analisePermitida(p)) status = 'bloqueado: sem consentimento';
      else {
        status = 'enviado';
        try {
          var dl = window.dataLayer = window.dataLayer || [];
          if (dados.ecommerce) dl.push({ ecommerce: null }); // limpa o ecommerce do evento anterior (padrão GA4)
          dl.push(junta({ event: nome }, dados));
        } catch (e) { status = 'erro no dataLayer'; }
        try {
          var a = window.Shopify && window.Shopify.analytics;
          if (a && typeof a.publish === 'function') a.publish('r130_' + nome, dados);
          else status += ' (sem Shopify.analytics)';
        } catch (e) { status += ' (erro no publish)'; }
      }
      registrar(nome, dados, nota ? status + ' · ' + nota : status);
    });
  }
  function emitir(nome, campos) {
    try { entregar(nome, limparDados(junta(base(), campos || {}))); } catch (e) {}
  }
  // Ação que troca de página na hora (filtro, seletor da home): vai na próxima página, para não se perder na troca.
  function adiar(nome, campos) {
    try {
      var lista = JSON.parse(ssLer(K_PEND) || '[]') || [];
      lista.push({ n: nome, d: limparDados(junta(base(), campos || {})), t: Date.now() });
      ssGravar(K_PEND, JSON.stringify(lista.slice(-10)));
    } catch (e) {}
  }
  function soltarAdiados() {
    var lista;
    try { lista = JSON.parse(ssLer(K_PEND) || '[]') || []; } catch (e) { lista = []; }
    ssGravar(K_PEND, null);
    lista.forEach(function (it) {
      if (it && it.n && Date.now() - it.t < 10 * 60 * 1000) entregar(it.n, it.d, 'da página anterior');
    });
  }

  /* ---------------- carrinho (dados do r130:carrinho, que vem do /cart.js) ---------------- */
  var cart = { atual: null, mapa: {}, mapaAntes: null, addTs: 0, ultimoAdd: null, abridor: null, paginaContada: false };
  function itensGa(c) {
    return (c && c.items || []).slice(0, 20).map(function (it) {
      return { item_id: texto(it.sku || it.variant_id, 40), item_name: texto(it.product_title, 100), price: Math.round(it.final_price != null ? it.final_price : it.price) / 100, quantity: it.quantity };
    });
  }
  function resumoCarrinho(c) {
    return { valor: c ? c.total_price / 100 : 0, itens: c ? c.item_count : 0, ecommerce: { currency: (c && c.currency) || 'BRL', value: c ? c.total_price / 100 : 0, items: itensGa(c) } };
  }
  document.addEventListener('r130:carrinho', function (ev) {
    var c = ev.detail;
    if (!c || !c.items) return;
    cart.mapaAntes = cart.atual ? cart.mapa : null;
    cart.atual = c;
    cart.mapa = {};
    c.items.forEach(function (it) { cart.mapa[it.variant_id] = (cart.mapa[it.variant_id] || 0) + it.quantity; });
    if (pagina() === 'carrinho' && !cart.paginaContada) {
      cart.paginaContada = true;
      emitir('carrinho', junta({ origem: 'carrinho/pagina_carrinho', secao: 'pagina_carrinho' }, resumoCarrinho(c)));
    }
  });
  // Peça adicionada (assets/r130-carrinho.js dispara depois de atualizar o carrinho; o "Desfazer" não dispara).
  document.addEventListener('product-added', function (ev) {
    var it = ev.detail || {};
    cart.addTs = Date.now();
    var v = it.variant_id || it.id;
    var qtd = cart.mapaAntes ? (cart.mapa[v] || 0) - (cart.mapaAntes[v] || 0) : 0;
    var ctx = cart.ultimoAdd && Date.now() - cart.ultimoAdd.t < 15000 ? cart.ultimoAdd : null;
    if (qtd <= 0) qtd = (ctx && ctx.qtd) || 1;
    var preco = Math.round(it.final_price != null ? it.final_price : (it.price || 0)) / 100;
    emitir('adicionar_ao_carrinho', junta(ctx ? { origem: ctx.origem, secao: ctx.secao } : { origem: pagina() + '/pagina' }, {
      sku: texto(it.sku || v, 40),
      valor: Math.round(preco * qtd * 100) / 100,
      ecommerce: { currency: (cart.atual && cart.atual.currency) || 'BRL', value: Math.round(preco * qtd * 100) / 100,
        items: [{ item_id: texto(it.sku || v, 40), item_name: texto(it.product_title, 100), price: preco, quantity: qtd }] }
    }));
  });
  // Quem pediu a peça: o formulário de compra (página do produto ou cartão de vitrine).
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM' || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    var q = f.querySelector('[name="quantity"]');
    cart.ultimoAdd = junta(contexto(f), { t: Date.now(), qtd: q ? parseInt(q.value, 10) || 1 : 1 });
  }, true);
  // Gaveta aberta pela pessoa (o ícone, a barra do celular). Aberta sozinha depois de adicionar não conta: já contou a adição.
  document.addEventListener('r130:carrinho-aberto', function () {
    var t0 = Date.now();
    setTimeout(function () {
      if (cart.addTs >= t0 - 50) return;
      var ab = cart.abridor && Date.now() - cart.abridor.t < 3000 ? cart.abridor : null;
      emitir('carrinho', junta(ab ? { origem: ab.origem, secao: ab.secao } : { origem: pagina() + '/gaveta_carrinho', secao: 'gaveta_carrinho' }, resumoCarrinho(cart.atual)));
    }, 0);
  });

  /* ---------------- cliques ---------------- */
  var chassiAbridor = null, garagemAbridor = null, aviseAbridor = null;
  function recenteAb(ab, ms) { return ab && Date.now() - ab.t < ms ? ab : null; }
  // Envio de formulário que vai trocar de página agora (o da página das oficinas, por exemplo): o que acontece
  // dentro dele vai na próxima página. Formulário de diálogo (painel do chassi, Meu carro) não troca de página.
  function vaiSair() {
    var e = window.event;
    return !!(e && e.type === 'submit' && !e.defaultPrevented && e.target && e.target.getAttribute &&
      (e.target.getAttribute('method') || '').toLowerCase() !== 'dialog');
  }
  var dlgChassi = null;
  function dlgCh() { return dlgChassi || (dlgChassi = document.getElementById('r130-chassi')); }

  function contarWhats(ctx, via, el) {
    if (recente('wa', 1500)) return;
    var mandar = vaiSair() ? adiar : emitir;
    var campos = junta({ via: via }, ctx);
    if (pagina() === 'produto' && ds.sku && !perto(el, '.r130-pc')) campos.sku = texto(ds.sku, 40);
    mandar('whatsapp_clique', campos);
    // Peça sem estoque: o "Consultar no WhatsApp" do cartão, o WhatsApp do "Avise-me" ou o da página de um produto esgotado.
    var card = perto(el, '.r130-pc--consulta, [data-r130-sob-consulta], #r130-avise');
    if (card || (pagina() === 'produto' && ds.disponivel === 'false' && !perto(el, '.r130-pc'))) {
      var sc = { origem: ctx.origem, secao: ctx.secao, sku: '' };
      if (card) {
        var a = perto(el, 'a[href]');
        var m = a && /[?&]text=([^&#]*)/.exec(a.getAttribute('href') || '');
        var msg = '';
        try { msg = m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : ''; } catch (e) {}
        var cod = /c[oó]digo:?\s*([^\s()]+)/i.exec(msg); // "Código: CXM2003" (cartão) ou "(código CXM2003)" (Avise-me)
        sc.sku = cod ? texto(cod[1], 40) : '';
        var link = card.querySelector('a[href*="/products/"]');
        if (link) sc.produto = texto((link.getAttribute('href').split('?')[0].split('/products/')[1] || ''), 100);
      } else sc.sku = texto(ds.sku, 40);
      mandar('sob_consulta_whatsapp', sc);
    }
  }

  // Link de WhatsApp: decide no fim do clique (se algum script cancelou a navegação, não abriu o WhatsApp;
  // é o caso do link com [data-r130-chassi-abrir], que abre o painel do chassi).
  var linkPend = [];
  function aoClicarLink(ev) {
    if (ev.type === 'auxclick' && ev.button !== 1) return;
    var a = perto(ev.target, 'a[href]');
    if (!a || !ehWhats(a.href)) return;
    var item = { ev: ev, a: a, ctx: contexto(a), feito: false };
    linkPend.push(item);
    setTimeout(function () { decidirLink(item); }, 0); // se algum script parar a propagação antes da janela
  }
  function decidirLink(item) {
    if (item.feito) return;
    item.feito = true;
    linkPend = linkPend.filter(function (x) { return x !== item; });
    if (item.ev.defaultPrevented) {
      if (item.a.hasAttribute('data-r130-chassi-abrir')) chassiAbridor = junta({ t: Date.now() }, item.ctx);
      return;
    }
    contarWhats(item.ctx, 'link', item.a);
  }
  function fimLink(ev) { linkPend.slice().forEach(function (x) { if (x.ev === ev) decidirLink(x); }); }
  document.addEventListener('click', aoClicarLink, true);
  document.addEventListener('auxclick', aoClicarLink, true);
  window.addEventListener('click', fimLink);
  window.addEventListener('auxclick', fimLink);

  // WhatsApp aberto por script: o "Falar no WhatsApp" do painel do chassi e apps (botão flutuante).
  var abrirAntes = window.open;
  window.open = function (url) {
    try {
      if (url && ehWhats(String(url))) {
        var dc = dlgCh();
        if (dc && dc.open) {
          var ab = chassiAbridor && Date.now() - chassiAbridor.t < 30 * 60 * 1000 ? chassiAbridor : { secao: 'painel_chassi', origem: pagina() + '/painel_chassi' };
          contarWhats({ secao: ab.secao, origem: ab.origem }, 'painel_chassi', dc);
        } else {
          var alvo = window.event && window.event.target && window.event.target.nodeType === 1 ? window.event.target : null;
          contarWhats(alvo ? contexto(alvo) : { secao: 'script', origem: pagina() + '/script' }, 'janela', alvo);
        }
      }
    } catch (e) {}
    return abrirAntes.apply(window, arguments);
  };

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var g = t.closest('[data-r130-garagem-abrir], [data-r130-abrir-garagem]');
    if (g) garagemAbridor = junta({ t: Date.now() }, contexto(g));
    var c = t.closest('[data-r130-carrinho-abrir], [data-r130-mbar-carrinho], .js-cart-icon-container, .header-cart, a[href$="/cart"]');
    if (c) cart.abridor = junta({ t: Date.now() }, contexto(c));
    if (t.closest('.js-quick-shop')) cart.ultimoAdd = junta(contexto(t), { t: Date.now(), qtd: 1 });
    var av = t.closest('[data-r130-avise-abrir]');
    if (av) aviseAbridor = junta({ t: Date.now() }, contexto(av));
    // Barra Montadora / Modelo / Ano das coleções (assets/filter.js): só vale com os 3 campos escolhidos.
    var bt = t.closest('.js-filter-container .js-btn-submit');
    if (bt) {
      var box = bt.closest('.js-filter-container');
      var v = [1, 2, 3].map(function (i) { var el = box.querySelector('.chosen-container[data-field-index="' + i + '"]'); return el ? el.getAttribute('data-value') || '' : ''; });
      if (v[0] && v[1] && v[2]) adiar('filtro_veiculo', junta(contexto(box), { montadora: nomeMontadora(v[0]), modelo: texto(v[1], 40).toUpperCase(), ano: /^\d{4}$/.test(v[2]) ? Number(v[2]) : texto(v[2], 10) }));
    }
  }, true);

  // Finalizar compra (gaveta ou página do carrinho). O formulário só envia com os termos aceitos.
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || f.tagName !== 'FORM' || ev.defaultPrevented) return;
    var b = ev.submitter;
    if (!(b && b.name === 'checkout') && !(f.querySelector('[name="checkout"]') && !b)) return;
    var sec = perto(f, '#r130-carrinho') ? 'gaveta_carrinho' : 'pagina_carrinho';
    emitir('checkout_inicio', junta({ origem: pagina() + '/' + sec, secao: sec }, resumoCarrinho(cart.atual)));
  });

  // Seletor do topo da home (assets/r130-seletor.js): grava o carro e vai para a coleção.
  function chaveCarro(c) { return c && c.brand ? [c.brand, c.model, c.year || ''].join('|').toUpperCase() : ''; }
  var carroNaCarga = chaveCarro(carroSalvo());
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!f || !f.matches || !f.matches('[data-r130-seletor]')) return;
    var mont = f.querySelector('[name="montadora"]'), mod = f.querySelector('[name="modelo"]'), ano = f.querySelector('[name="ano"]');
    if (!mont || !mod || !mont.value || !mod.value || (ano && ano.required && !ano.value)) return; // o seletor só avisou o que falta
    var c = carroSalvo();
    var ctx = contexto(f);
    var campos = { montadora: c ? nomeMontadora(c.brand) : '', modelo: c ? texto(c.model, 40) : '', ano: c && c.year ? c.year : '' };
    if (c && chaveCarro(c) !== carroNaCarga) adiar('carro_salvo', junta(junta({}, ctx), campos));
    var motor = f.querySelector('[name="motor"]');
    adiar('filtro_veiculo', junta(junta({}, ctx), junta(campos, { motor: motor ? texto(motor.value, 20) : '' })));
    carroNaCarga = chaveCarro(c);
  });

  /* ---------------- eventos dos outros scripts ---------------- */
  // Carro salvo no "Meu carro" (snippets/130r-garagem-virtual.liquid).
  document.addEventListener('r130:garagem', function (ev) {
    var c = ev.detail;
    carroNaCarga = chaveCarro(c);
    if (!c || !c.brand) return;
    var ab = garagemAbridor && Date.now() - garagemAbridor.t < 30 * 60 * 1000 ? garagemAbridor : { secao: 'meu_carro', origem: pagina() + '/meu_carro' };
    emitir('carro_salvo', { origem: ab.origem, secao: ab.secao, montadora: nomeMontadora(c.brand), modelo: texto(c.model, 40), ano: c.year || '' });
  });
  // Chassi salvo (assets/r130-chassi.js): o evento só diz se salvou ou apagou, nunca o chassi.
  document.addEventListener('r130:chassi', function (ev) {
    if (!ev.detail || !ev.detail.salvo || recente('chassi', 1000)) return;
    var ctx = contexto(document.activeElement);
    if (ctx.secao === 'painel_chassi' && chassiAbridor) ctx = { secao: chassiAbridor.secao, origem: chassiAbridor.origem, via: 'painel_chassi' };
    emitir('chassi_salvo', ctx);
  });
  // "Avise-me" dos esgotados (assets/r130-avise.js) e cadastro de empresa da página das oficinas (assets/r130-lp.js):
  // os dois disparam logo antes do envio nativo do formulário, que troca de página. Por isso vão na próxima página.
  // Só o SKU, o tipo e a origem; nada do contato da pessoa (e-mail, telefone, CNPJ).
  document.addEventListener('r130:avise-me', function (ev) {
    var d = ev.detail || {};
    var ab = recenteAb(aviseAbridor, 30 * 60 * 1000) || contexto(document.activeElement);
    adiar('avise_me', { sku: texto(d.sku, 40), local: texto(d.origem, 40), origem: ab.origem, secao: ab.secao });
  });
  var TIPOS_LEAD = { oficina: 1, autopecas: 1, revenda: 1, outro: 1 };
  document.addEventListener('r130:lead-b2b', function (ev) {
    var d = ev.detail || {};
    var ctx = contexto(document.activeElement);
    adiar('lead_b2b', { tipo: TIPOS_LEAD[d.tipo] ? d.tipo : 'outro', local: texto(d.origem, 40), origem: ctx.origem, secao: ctx.secao });
  });

  /* ---------------- busca ---------------- */
  function buscaPagina() {
    if (pagina() !== 'busca') return;
    var ps = new URLSearchParams(location.search);
    var q = ps.get('q');
    if (!q || ps.get('view') || (ps.get('page') && ps.get('page') !== '1')) return;
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && (nav.type === 'reload' || nav.type === 'back_forward')) return; // a mesma busca de novo
    var total = parseInt(ds.buscaTotal, 10);
    if (isNaN(total)) total = document.querySelectorAll('.page_search-results .product-item').length;
    var campos = { tipo: 'pagina', termo: anonimizar(q), resultados: total, sem_resultado: total === 0, origem: 'busca/pagina' };
    // Código sem hífen que não achou nada: o assets/r130-busca.js pode trocar o endereço pela forma que acha; espera.
    var an = window.R130Busca && window.R130Busca.analisar ? window.R130Busca.analisar(q) : null;
    if (total === 0 && an && an.codigo && an.variantes.length > 1) setTimeout(function () { emitir('busca', campos); }, 3000);
    else emitir('busca', campos);
  }
  // Sugestões enquanto digita (assets/r130-busca.js): conta o termo quando a lista para de mudar.
  var sug = { painel: null, timer: 0, termos: {}, pendente: null };
  function lerSugestao() {
    var p = sug.painel;
    if (!p || p.hidden) return null;
    var campo = document.querySelector('input[name="q"][aria-expanded="true"]');
    var termo = campo ? texto(campo.value, 200) : '';
    if (termo.length < 2) return null;
    var pecas = p.querySelectorAll('.r130-sug__opt--prod').length;
    var cats = p.querySelectorAll('.r130-sug__opt--col').length;
    return { termo: termo, campos: { tipo: 'sugestao', termo: anonimizar(termo), resultados: pecas, categorias: cats, sem_resultado: pecas + cats === 0, origem: pagina() + '/' + (secaoDe(campo) || 'busca') } };
  }
  function soltarSugestao() {
    clearTimeout(sug.timer);
    var s = sug.pendente;
    sug.pendente = null;
    if (!s) return;
    var chave = s.termo.toUpperCase();
    if (sug.termos[chave]) return;
    sug.termos[chave] = 1;
    emitir('busca', s.campos);
  }
  function vigiarSugestoes(p) {
    sug.painel = p;
    new MutationObserver(function () {
      var s = lerSugestao();
      clearTimeout(sug.timer);
      if (!s) return;
      sug.pendente = s;
      sug.timer = setTimeout(soltarSugestao, 1500);
    }).observe(p, { attributes: true, attributeFilter: ['hidden'], childList: true, subtree: true });
    p.addEventListener('pointerdown', function () { var s = lerSugestao(); if (s) { sug.pendente = s; soltarSugestao(); } }, true);
  }
  document.addEventListener('submit', function (ev) {
    // Enviou a busca: quem conta é a página de resultados (tipo "pagina").
    var f = ev.target;
    if (f && f.querySelector && f.querySelector('input[name="q"]')) { clearTimeout(sug.timer); sug.pendente = null; }
  }, true);

  /* ---------------- menus e "Meu carro" (atributos que os scripts do tema já mudam) ---------------- */
  function vigiarAtributos() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (lista) {
      lista.forEach(function (m) {
        var el = m.target;
        if (m.attributeName === 'aria-expanded' && el.getAttribute('aria-expanded') === 'true') {
          if (el.matches('[data-r130-mega-gatilho]')) {
            var nome = texto(el.textContent, 40);
            if (primeiraVez('mega:' + nome)) emitir('mega_menu_abre', { menu: nome, tipo: 'computador', origem: pagina() + '/menu' });
          } else if (el.matches('[data-r130-gaveta-abrir]')) {
            if (primeiraVez('gaveta')) emitir('mega_menu_abre', { menu: 'Menu', tipo: 'celular', origem: pagina() + '/' + (secaoDe(el) || 'menu_celular') });
          } else if (el.matches('[data-r130-gav-abre]')) {
            var sub = texto(el.textContent, 40);
            if (primeiraVez('gav:' + sub)) emitir('mega_menu_abre', { menu: sub, tipo: 'celular', origem: pagina() + '/menu_celular' });
          }
        } else if (m.attributeName === 'open' && el.id === 'r130-garage-modal' && el.hasAttribute('open') && !recente('garagem', 800)) {
          var ab = garagemAbridor && Date.now() - garagemAbridor.t < 3000 ? garagemAbridor : { secao: 'script', origem: pagina() + '/script' };
          emitir('meu_carro_abre', { origem: ab.origem, secao: ab.secao });
        }
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['aria-expanded', 'open'], subtree: true });
    // Lista de sugestões: criada pelo r130-busca.js no fim do <body> quando a pessoa começa a digitar.
    var p0 = document.querySelector('body > .r130-sug');
    if (p0) vigiarSugestoes(p0);
    else new MutationObserver(function (lista, obs) {
      lista.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1 && n.classList.contains('r130-sug') && !sug.painel) { vigiarSugestoes(n); obs.disconnect(); }
        });
      });
    }).observe(document.body, { childList: true });
  }

  // O "Falar no WhatsApp" do painel do chassi, caso o r130-chassi.js tenha carregado antes deste arquivo
  // (aí ele abre o WhatsApp sem passar pelo window.open daqui). Com o painel ainda aberto, o chassi era inválido.
  document.addEventListener('submit', function (ev) {
    var dc = dlgCh();
    if (!dc || ev.target !== dc.querySelector('form')) return;
    setTimeout(function () {
      if (dc.open || recente('wa', 1500)) return;
      var ab = chassiAbridor || { secao: 'painel_chassi', origem: pagina() + '/painel_chassi' };
      emitir('whatsapp_clique', { via: 'painel_chassi', origem: ab.origem, secao: ab.secao });
    }, 0);
  });

  /* ---------------- painel de conferência ---------------- */
  var painel = null;
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return '&#' + c.charCodeAt(0) + ';'; }); }
  function resumo(d) {
    var ocultos = { pagina: 1, debug_mode: 1, ecommerce: 1 };
    return Object.keys(d || {}).filter(function (k) { return !ocultos[k]; }).map(function (k) {
      var v = d[k];
      if (v === true) v = 'sim'; else if (v === false) v = 'não';
      return k + '=' + v;
    }).join(' · ');
  }
  function estadoPriv() {
    var p = apiPriv();
    if (!p) return 'privacidade: carregando';
    return 'análise: ' + (analisePermitida(p) ? 'permitida' : 'sem consentimento');
  }
  function desenhar() {
    if (!debug || !document.body) return;
    if (!painel) {
      var css = document.createElement('style');
      css.textContent =
        '.r130-med{position:fixed;left:8px;bottom:8px;z-index:2147483600;width:min(400px,calc(100vw - 16px));max-height:46vh;display:flex;flex-direction:column;background:#fff;color:#1e1e1e;border:1px solid #e6e6e6;border-radius:8px;box-shadow:0 8px 28px rgba(0,0,0,.18);font:12.5px/1.4 Rubik,system-ui,sans-serif;text-align:left}' +
        '@media (max-width:991.98px){.r130-med{bottom:76px}}' +
        '.r130-med__topo{display:flex;align-items:center;gap:8px;padding:8px 10px;border-bottom:1px solid #e6e6e6;background:#f6f6f6;border-radius:8px 8px 0 0}' +
        '.r130-med__tit{flex:1;margin:0;padding:0;border:0;background:none;font:inherit;font-weight:700;color:#1e1e1e;text-align:left;cursor:pointer}' +
        '.r130-med__priv{color:#666;font-size:11.5px}' +
        '.r130-med__bt{min-height:28px;padding:0 8px;border:1px solid #e6e6e6;border-radius:6px;background:#fff;font:inherit;font-size:11.5px;color:#1e1e1e;cursor:pointer}' +
        '.r130-med__lista{margin:0;padding:0;list-style:none;overflow:auto}' +
        '.r130-med__lista li{margin:0;padding:6px 10px;border-bottom:1px solid #eee}' +
        '.r130-med__ev{font-weight:700}.r130-med__h{float:right;color:#666;font-size:11px}' +
        '.r130-med__st{display:inline-block;margin-left:6px;padding:0 6px;border-radius:4px;font-size:11px;background:#e9f6ef;color:#14803f}' +
        '.r130-med__st--nao{background:#fbe9e7;color:#ba1b0f}' +
        '.r130-med__cp{color:#444;word-break:break-word}' +
        '.r130-med__vazio{padding:10px;color:#666}' +
        '.r130-med--fechado .r130-med__lista,.r130-med--fechado .r130-med__bt--limpar{display:none}';
      document.head.appendChild(css);
      painel = document.createElement('section');
      painel.className = 'r130-med';
      painel.setAttribute('aria-label', 'Medição: eventos desta sessão');
      painel.innerHTML = '<div class="r130-med__topo"><button type="button" class="r130-med__tit" aria-expanded="true"></button>' +
        '<span class="r130-med__priv"></span><button type="button" class="r130-med__bt r130-med__bt--limpar">Limpar</button>' +
        '<button type="button" class="r130-med__bt r130-med__bt--sair" title="Desliga a conferência nesta aba">Sair</button></div><ol class="r130-med__lista"></ol>';
      document.body.appendChild(painel);
      if (ssLer(K_PAINEL) === 'fechado') painel.classList.add('r130-med--fechado');
      painel.querySelector('.r130-med__tit').addEventListener('click', function () {
        var f = painel.classList.toggle('r130-med--fechado');
        this.setAttribute('aria-expanded', f ? 'false' : 'true');
        ssGravar(K_PAINEL, f ? 'fechado' : null);
      });
      painel.querySelector('.r130-med__bt--limpar').addEventListener('click', function () { ssGravar(K_LOG, null); desenhar(); });
      painel.querySelector('.r130-med__bt--sair').addEventListener('click', function () {
        ssGravar(K_DEBUG, null); ssGravar(K_LOG, null); debug = false; painel.remove(); painel = null;
      });
    }
    var log = lerLog();
    painel.querySelector('.r130-med__tit').textContent = 'Medição · ' + log.length + (log.length === 1 ? ' evento' : ' eventos');
    painel.querySelector('.r130-med__priv').textContent = estadoPriv();
    var ol = painel.querySelector('.r130-med__lista');
    ol.innerHTML = log.length ? log.slice().reverse().map(function (e) {
      var ok = /^enviado/.test(e.s);
      return '<li><span class="r130-med__h">' + esc(e.h) + '</span><span class="r130-med__ev">' + esc(e.n) + '</span>' +
        '<span class="r130-med__st' + (ok ? '' : ' r130-med__st--nao') + '">' + esc(e.s) + '</span>' +
        '<div class="r130-med__cp">' + esc((e.d && e.d.pagina ? e.d.pagina + ' · ' : '') + resumo(e.d)) + '</div></li>';
    }).join('') : '<li class="r130-med__vazio">Nenhum evento ainda. Clique no WhatsApp, salve o carro, busque uma peça…</li>';
  }

  /* ---------------- início ---------------- */
  // Depois de todos os scripts "defer" (o r130-busca.js carrega depois deste): DOMContentLoaded ou, no pior caso, load.
  var iniciado = false;
  function iniciar() {
    if (iniciado) return;
    iniciado = true;
    dlgCh();
    vigiarAtributos();
    soltarAdiados();
    buscaPagina();
    if (debug) { desenhar(); comPrivacidade(function () { desenhar(); }); }
    document.addEventListener('visitorConsentCollected', desenhar);
  }
  if (document.readyState === 'complete') iniciar();
  else { document.addEventListener('DOMContentLoaded', iniciar); window.addEventListener('load', iniciar); }

  window.R130Medicao = { emitir: emitir, anonimizar: anonimizar, eventos: lerLog };
})();
